import { render } from "./TokenGenerator.vue?vue&type=template&id=4449c072&scoped=true"
import script from "./TokenGenerator.vue?vue&type=script&lang=js"
export * from "./TokenGenerator.vue?vue&type=script&lang=js"

import "./TokenGenerator.vue?vue&type=style&index=0&id=4449c072&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4449c072"]])

export default __exports__